module.exports = "<div [id]=\"containerId\"></div>\n";